const PRODUCTS_INDEX_NAME = 'Products';
const STORES_INDEX_NAME = 'Stores';
const RECIPES_INDEX_NAME = 'Recipes';

module.exports = {
  PRODUCTS_INDEX_NAME,
  STORES_INDEX_NAME,
  RECIPES_INDEX_NAME
};
